import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "policies-section my-4" };
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = { class: "row g-3" };
const _hoisted_4 = { class: "col-12 col-md-6" };
const _hoisted_5 = { class: "policy-box" };
const _hoisted_6 = { class: "mb-1" };
const _hoisted_7 = { class: "mb-0" };
const _hoisted_8 = { class: "col-12 col-md-6" };
const _hoisted_9 = { class: "policy-box" };
const _hoisted_10 = { class: "mb-0" };
const _hoisted_11 = { class: "col-12 col-md-6" };
const _hoisted_12 = { class: "policy-box" };
const _hoisted_13 = { class: "mb-0" };
const _hoisted_14 = { class: "col-12 col-md-6" };
const _hoisted_15 = { class: "policy-box" };
const _hoisted_16 = { class: "mb-0" };
const _hoisted_17 = { class: "col-12" };
const _hoisted_18 = { class: "policy-box" };
const _hoisted_19 = { class: "mb-0" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PoliciesSection',
    props: {
        policies: {},
        payments: {}
    },
    setup(__props) {
        const props = __props;
        const paymentsText = computed(() => {
            const p = props.payments || [];
            return p.length ? p.join(', ') : 'Consultar métodos disponibles';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                        _createElementVNode("i", { class: "fas fa-file-alt me-2" }),
                        _createTextVNode("Políticas y reglas")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "h6" }, "Check-in / Check-out", -1)),
                                _createElementVNode("p", _hoisted_6, [
                                    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Check-in:", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.policies?.checkIn || 'Consultar'), 1)
                                ]),
                                _createElementVNode("p", _hoisted_7, [
                                    _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Check-out:", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.policies?.checkOut || 'Consultar'), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "h6" }, "Cancelación", -1)),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.policies?.cancellation || 'Consultar condiciones de cancelación'), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "h6" }, "Niños y camas extra", -1)),
                                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.policies?.children || 'Consultar'), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "h6" }, "Mascotas", -1)),
                                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.policies?.pets || 'No permitido'), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "h6" }, "Formas de pago", -1)),
                                _createElementVNode("p", _hoisted_19, _toDisplayString(paymentsText.value), 1)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
